import Footer from '../components/Footer/Footer.js';
import { connect } from 'react-redux';
import { redux as apiRedux } from '../api';
const { clearUserInfo, clearCurrentInfo } = apiRedux.actions;

const mapDispatchToProps = dispatch => {
  return {
    clearUserInfo: data => dispatch(clearUserInfo(data)),
    clearCurrentInfo: data => dispatch(clearCurrentInfo(data)),
  };
};
const ConnectedFooter = connect(
  null,
  mapDispatchToProps
)(Footer);

export default ConnectedFooter;
